// extracted by mini-css-extract-plugin
export default {"spinner-border":"IXI+v","spinner-border-sm":"QSELP","spinner-grow":"h1rUv","spinner-grow-sm":"jOtcQ"};